import { CircularProgress } from '@mui/material'
import { createPortal } from 'react-dom'

export const PageLoader = ({ open }: { open: boolean }) => {
    console.log('PageLoader rendered with open:', open, new Date().toISOString())
    if (!open) {
        console.log('PageLoader returning null - not open')
        return null
    }

    console.log('PageLoader rendering modal overlay - IS VISIBLE')

    const modalContent = (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 99999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                pointerEvents: 'auto',
                cursor: 'wait',
            }}
            onClick={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '16px',
                    padding: '24px',
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                }}
            >
                <CircularProgress size={80} thickness={4} />
            </div>
        </div>
    )

    return createPortal(modalContent, document.body)
}
